@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.input {
  height: 48px;
  width: 100%;
  padding: 13px 16px;
  border-radius: 8px;
  border: 1px solid v.$gray-border-color;
  background: v.$navy-color;
  color: v.$gray-light-color;
  @include t.text(14px, 22px, "normal");
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.input::placeholder {
  color: v.$gray-dark-color;
}

.input:not(.input--invalid):hover {
  border-color: v.$green-dark-color;
}

.input--disabled {
  cursor: not-allowed;
}

.input:not(.input--invalid):focus,
.input:not(.input--invalid):focus-visible {
  outline: none;
  border-color: v.$green-color;
}

.input--invalid {
  border-color: v.$error-color;
}

.input--invalid:focus,
.input--invalid:focus-visible {
  border-color: v.$error-color;
  box-shadow: v.$shadow-focus-red;
}

.input--chinese-brothers {
  background: v.$chinese-brothers-input-bg;
  border-color: v.$chinese-brothers-input-border;
  color: v.$white-color;
}

.input--chinese-brothers::placeholder {
  color: rgb(255 255 255 / 40%);
}

.input--chinese-brothers:not(.input--invalid):hover {
  border-color: v.$chinese-brothers-input-border-hover;
}

.input--chinese-brothers:not(.input--invalid):focus,
.input--chinese-brothers:not(.input--invalid):focus-visible {
  outline: none;
  border-color: v.$chinese-brothers-input-border-active;
  box-shadow: none;
}

.input--chinese-brothers.input--invalid {
  border-color: v.$chinese-brothers-input-border-error;
  box-shadow: none;
}

.input--chinese-brothers.input--invalid:focus,
.input--chinese-brothers.input--invalid:focus-visible {
  border-color: v.$chinese-brothers-input-border-error;
  box-shadow: none;
}

.input--embedded {
  min-height: 0;
  width: 100%;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.input--embedded:hover {
  border-color: transparent;
}

.input--embedded:focus,
.input--embedded:focus-visible {
  border: none;
  box-shadow: none;
}

.input--embedded.input--invalid {
  border-color: transparent;
  box-shadow: none;
}
